export default "__VITE_PUBLIC_ASSET__9b5a77d6__"